import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState as e, useMemo as r, useEffect as t } from "react";
import { isBrowser as n } from "@phx-husky/browser-helpers";
var a;
!function (e) {
  e.GT = "Gt", e.LT = "Lt", e.GE = "Ge", e.LE = "Le", e.EQ = "Eq", e.NE = "Ne";
}(a || (a = {}));
var u = function u(e, r, t) {
    if ([null, void 0, NaN].includes(e)) return !1;
    var n = function (e, r) {
      return "boolean" == typeof e ? "true" === r : "number" == typeof e ? parseInt(r, 10) : e instanceof Date ? new Date(r) : Array.isArray(r) ? r.filter(function (e) {
        return e;
      }) : r;
    }(e, r);
    switch (t) {
      case a.EQ:
        return Array.isArray(n) ? n.includes((null == e ? void 0 : e.value) || e) : n === e;
      case a.NE:
        return Array.isArray(n) ? !n.includes((null == e ? void 0 : e.value) || e) : n !== e;
      case a.GT:
        return e > n;
      case a.GE:
        return e >= n;
      case a.LT:
        return e < n;
      case a.LE:
        return e <= n;
      default:
        return null;
    }
  },
  o = function o(n, a) {
    var _e = e(!0),
      _e2 = _slicedToArray(_e, 2),
      o = _e2[0],
      i = _e2[1],
      s = r(function () {
        return a || [];
      }, [a]),
      c = s.map(function (_ref) {
        var e = _ref.fieldAlias;
        return n(e);
      });
    return t(function () {
      var e = s.every(function (_ref2, t) {
        var e = _ref2.value,
          r = _ref2.operator;
        return u(c[t], e, r);
      });
      i(e);
    }, [s, c]), !s.length || o;
  },
  i = ["utm_id", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"],
  s = function s(e) {
    if (!e) return;
    var r = /\/(.*)\/(.*)/.exec("".concat(e)) || /\/(.*)\/(.*)/.exec("/".concat(e, "/"));
    return r ? new RegExp(r[1], r[2]) : void 0;
  },
  c = function c(e) {
    var r;
    return e ? null === (r = Object.values(JSON.parse(e).entityMap)) || void 0 === r ? void 0 : r.filter(function (e) {
      return "LEGAL-DOCUMENT" === e.type;
    }) : [];
  },
  l = function l() {
    if (n()) return i.map(function (e) {
      var r = new URLSearchParams(window.location.search);
      return {
        name: e,
        value: new URLSearchParams(r).get(e) || void 0
      };
    });
  };
export { a as ConditionOperator, c as getQueries, l as getUtmParameters, s as parseRegex, o as useConditionsWatch };